var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBell = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6417 7.71825C13.1518 6.37356 14.4779 5.38086 15.9999 5.38086C17.5209 5.38086 18.8477 6.37339 19.358 7.71825C22.1711 9.00152 24.1343 11.8507 24.1343 15.1231V19.8242C25.411 20.1124 26.3452 21.2394 26.3452 22.6105C26.3452 24.1815 25.0546 25.4183 23.4874 25.4183H19.8964C19.1905 26.8701 17.7034 27.8807 16 27.8807C14.2965 27.8807 12.8095 26.87 12.1036 25.4183H8.51261C6.94421 25.4183 5.65479 24.1811 5.65479 22.6105C5.65479 21.2382 6.58989 20.1123 7.86573 19.8242V15.1231C7.86573 11.85 9.82864 9.00139 12.6417 7.71825ZM15.9999 6.88086C15.0517 6.88086 14.2058 7.57045 13.9782 8.45856L13.884 8.82596L13.5323 8.96785C11.0906 9.95285 9.36573 12.3577 9.36573 15.1231V21.2527H8.51261C7.74666 21.2527 7.15479 21.844 7.15479 22.6105C7.15479 23.3202 7.73977 23.9183 8.51261 23.9183H13.1434L13.3156 24.4284C13.7 25.5668 14.7765 26.3807 16 26.3807C17.2235 26.3807 18.3 25.5669 18.6844 24.4284L18.8566 23.9183H23.4874C24.2596 23.9183 24.8452 23.3201 24.8452 22.6105C24.8452 21.8445 24.2539 21.2527 23.4874 21.2527H22.6343V15.1231C22.6343 12.3584 20.9091 9.95296 18.4675 8.96785L18.1158 8.82596L18.0216 8.45862C17.7938 7.57044 16.9473 6.88086 15.9999 6.88086Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell.6c6111e4607c90f26f3932a51696df96.svg";